import { Box, Typography } from '@material-ui/core'
import React from 'react'
import { LayoutType } from '../src/components/common/LayoutType'
import { useRouter } from 'next/router'
import Link from 'next/link'

export default function Error404() {
  const { asPath } = useRouter()
  const match = asPath.match(/^\/([^/]+)/)
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      height={'100vh'}
      flexDirection={'column'}
    >
      <div>
        <Typography>{'Not found'}</Typography>
      </div>
      {match ? (
        <Box>
          <Link href={match[0]} passHref>
            <a>
              <Typography>{'Back'}</Typography>
            </a>
          </Link>
        </Box>
      ) : null}
    </Box>
  )
}
Error404.layoutType = LayoutType.NONE
